/* eslint-disable react/prop-types */
import React from 'react';
import ReportingEmailPage from '../ReportingEmailPage';

/**
 * DPR Settings → Reporting Email: reuses project reporting email UI + Redux wiring.
 */
const DPRSettingsReportingEmailTab = ({ selectedProject }) => (
  <div className="dpr-settings-tab-content dpr-settings-reporting-email-tab">
    <ReportingEmailPage selectedProject={selectedProject} />
  </div>
);

export default DPRSettingsReportingEmailTab;
